export const services = [
  {
    slug: 'optimizacion-procesos',
    title: 'Optimización de procesos para pymes industriales y de servicios',
    shortTitle: 'Optimización de procesos',
    excerpt:
      'Revisión y rediseño de procesos críticos para reducir tiempos muertos, errores operativos y costes ocultos.',
    metaTitle: 'Optimización de procesos para pymes | Joan Chorto Consultor',
    metaDescription:
      'Servicio de optimización de procesos para pymes industriales, construcción y servicios. Reduce costes, tiempos y errores con un plan de mejora medible.',
    intro:
      'La optimización de procesos permite mejorar productividad sin aumentar estructura. Analizamos cómo fluye el trabajo entre equipos y aplicamos cambios concretos para ganar velocidad y control.',
    bullets: [
      'Mapeo de procesos end-to-end y detección de cuellos de botella.',
      'Estandarización operativa por áreas y responsables.',
      'Definición de KPI de eficiencia y seguimiento semanal.',
    ],
    outcome:
      'Resultado esperado: operaciones más estables, menos retrabajo y mejor margen operativo con la misma plantilla.',
    faqs: [
      {
        q: '¿Cuánto tarda una optimización de procesos?',
        a: 'El diagnóstico inicial se realiza en 2 a 3 semanas. La ejecución se despliega por fases según prioridad e impacto económico.',
      },
      {
        q: '¿Sirve para empresas pequeñas?',
        a: 'Sí. En pymes la mejora suele ser más visible porque elimina tareas duplicadas y problemas de coordinación entre áreas.',
      },
    ],
  },
  {
    slug: 'implantacion-sistemas-digitales',
    title: 'Implantación de sistemas digitales para mejorar la gestión empresarial',
    shortTitle: 'Implantación de sistemas digitales',
    excerpt:
      'Diseño e implantación de sistemas de trabajo digitales para conectar oficina, operaciones y dirección.',
    metaTitle: 'Implantación de sistemas digitales para pymes | Joan Chorto',
    metaDescription:
      'Implantación de sistemas digitales para empresas que quieren mejorar control operativo y acelerar decisiones con datos fiables.',
    intro:
      'La digitalización bien planteada no consiste en añadir herramientas, sino en diseñar un sistema de gestión coherente con la operación real de la empresa.',
    bullets: [
      'Diseño de procesos digitales alineados con negocio.',
      'Integración de herramientas existentes para evitar silos de información.',
      'Formación y acompañamiento para adopción real del sistema.',
    ],
    outcome:
      'Resultado esperado: visibilidad en tiempo real, menos dependencia de tareas manuales y mayor capacidad de respuesta en dirección.',
    faqs: [
      {
        q: '¿Hay que cambiar todas las herramientas actuales?',
        a: 'No. Se parte de la realidad actual y se sustituyen solo los puntos que frenan eficiencia o generan errores críticos.',
      },
      {
        q: '¿Incluye soporte tras la implantación?',
        a: 'Sí. Se incluye fase de estabilización para asegurar uso correcto, corregir incidencias y consolidar hábitos de trabajo.',
      },
    ],
  },
  {
    slug: 'erp-herramientas-propias',
    title: 'ERP y herramientas propias para control operativo y financiero',
    shortTitle: 'ERP y herramientas propias',
    excerpt:
      'Configuración de ERP y herramientas complementarias para mejorar trazabilidad, control de costes y rentabilidad.',
    metaTitle: 'ERP para pymes y herramientas propias | Joan Chorto Consultor',
    metaDescription:
      'Implantación y optimización de ERP para pymes con herramientas propias de control operativo y financiero orientadas a resultados.',
    intro:
      'El ERP debe trabajar para la empresa, no al revés. Configuramos procesos, cuadros de mando y reglas de control para transformar datos en decisiones ejecutivas.',
    bullets: [
      'Diseño funcional del ERP según procesos críticos.',
      'Automatizaciones para validación y cierre administrativo.',
      'Paneles para dirección con KPI de márgenes y productividad.',
    ],
    outcome:
      'Resultado esperado: menos tiempo de gestión administrativa, más trazabilidad y control económico por unidad de negocio.',
    faqs: [
      {
        q: '¿Trabajas con cualquier ERP?',
        a: 'Sí. La consultoría se adapta al ERP existente y se desarrollan módulos adicionales cuando el negocio lo requiere.',
      },
      {
        q: '¿Se puede implantar por fases?',
        a: 'Sí. Normalmente se priorizan áreas con mayor impacto económico para acelerar retorno y reducir riesgo de cambio.',
      },
    ],
  },
  {
    slug: 'desarrollo-medida-pymes',
    title: 'Desarrollo a medida para procesos empresariales complejos',
    shortTitle: 'Desarrollo a medida',
    excerpt:
      'Desarrollo de soluciones específicas cuando el negocio necesita flujos, validaciones y paneles propios.',
    metaTitle: 'Desarrollo a medida para pymes | Joan Chorto Consultor',
    metaDescription:
      'Desarrollo a medida para pymes industriales, construcción y servicios. Software orientado a procesos reales y mejora de rentabilidad.',
    intro:
      'Cuando una pyme tiene procesos diferenciados, el desarrollo a medida permite construir una capa operativa específica sin forzar el negocio a trabajar con limitaciones.',
    bullets: [
      'Análisis funcional y diseño orientado a operación real.',
      'Desarrollo incremental con entregas y validación continua.',
      'Integración con ERP, facturación y herramientas existentes.',
    ],
    outcome:
      'Resultado esperado: sistema propio alineado al negocio, reducción de fricción operativa y mayor escalabilidad.',
    faqs: [
      {
        q: '¿Cómo se controla el alcance del desarrollo?',
        a: 'Se define por fases con objetivos medibles y entregables claros para mantener foco en impacto y retorno.',
      },
      {
        q: '¿Puede convivir con herramientas actuales?',
        a: 'Sí. Se diseña para integrarse con el ecosistema existente y evitar sustituciones innecesarias.',
      },
    ],
  },
];

export const projects = [
  {
    slug: 'egea-arquitectura-optimizacion-proyectos',
    company: 'EGEA Arquitectura',
    title: 'EGEA Arquitectura: optimización de gestión de proyectos y control de plazos',
    sector: 'Arquitectura y gestión técnica',
    metaTitle: 'Caso EGEA Arquitectura | Optimización de procesos y plazos',
    metaDescription:
      'Caso real de EGEA Arquitectura: mejora de coordinación, control documental y reducción de retrasos en proyectos técnicos.',
    initial: 'Los equipos trabajaban con información dispersa entre correos, hojas de cálculo y plataformas no conectadas.',
    problem: 'Desviaciones de plazos, seguimiento incompleto de hitos y falta de visibilidad de carga real por proyecto.',
    action:
      'Se implantó un sistema único de planificación y seguimiento, con flujos de aprobación y panel de control de avance semanal.',
    results: ['-28% en retrasos de entregas', '+35% en visibilidad de carga técnica', '-22% en retrabajos documentales'],
    tools: 'Sistema digital de proyectos, automatización de estados y cuadro de mando de plazos.',
  },
  {
    slug: 'vim-house-digitalizacion-operaciones-construccion',
    company: 'VIM House',
    title: 'VIM House: digitalización operativa para empresa de construcción',
    sector: 'Construcción',
    metaTitle: 'Caso VIM House | Digitalización en construcción',
    metaDescription:
      'Proyecto de digitalización para VIM House: control de obra, trazabilidad de partes y mejora de facturación en construcción.',
    initial: 'La información de obra llegaba tarde a oficina y se producía acumulación de tareas administrativas al cierre de mes.',
    problem: 'Falta de control económico por obra y retraso en certificaciones y facturación.',
    action:
      'Se desplegó un flujo digital de partes diarios, control de costes por proyecto y validación de certificaciones.',
    results: ['+41% en velocidad de facturación', '-25% en incidencias administrativas', '+16% en margen por obra'],
    tools: 'ConstructPro, integración con facturación y panel de costes por proyecto.',
  },
  {
    slug: 'ajuntament-aldea-modernizacion-servicios-internos',
    company: "Ajuntament de L'Aldea",
    title: "Ajuntament de L'Aldea: modernización de procesos internos y trazabilidad",
    sector: 'Administración y servicios públicos',
    metaTitle: "Caso Ajuntament de L'Aldea | Modernización de gestión",
    metaDescription:
      "Caso de modernización interna en Ajuntament de L'Aldea: estandarización de procesos, trazabilidad y mejora de tiempos de gestión.",
    initial: 'Los procesos internos tenían pasos manuales repetidos y tiempos de respuesta variables entre departamentos.',
    problem: 'Baja trazabilidad de expedientes y dificultad para medir tiempos de resolución.',
    action:
      'Se estandarizaron circuitos internos, se digitalizaron validaciones y se implantó un seguimiento centralizado de estado.',
    results: ['-32% en tiempo medio de tramitación', '+44% en trazabilidad de expedientes', '-19% en tareas repetitivas'],
    tools: 'RegIT, flujos de aprobación y cuadro de mando de tiempos de respuesta.',
  },
  {
    slug: 'curmac-elevacions-eficiencia-servicio-tecnico',
    company: 'Curmac Elevacions',
    title: 'Curmac Elevacions: eficiencia operativa en servicio técnico y mantenimiento',
    sector: 'Servicios técnicos y mantenimiento',
    metaTitle: 'Caso Curmac Elevacions | Eficiencia operativa y mantenimiento',
    metaDescription:
      'Proyecto en Curmac Elevacions para mejorar eficiencia de servicio técnico, coordinación operativa y control de incidencias.',
    initial: 'La coordinación de técnicos y backoffice dependía de llamadas y registros manuales sin trazabilidad completa.',
    problem: 'Tiempos muertos en asignación, errores en cierre de intervenciones y baja visibilidad de rendimiento.',
    action:
      'Se diseñó una operativa digital para asignación, seguimiento y cierre de servicios con control de SLA.',
    results: ['-29% en tiempo de asignación', '+24% en productividad técnica', '-37% en incidencias de cierre'],
    tools: 'Avero, automatizaciones de asignación y dashboard de productividad.',
  },
];
